import cn from "classnames";
import { usePopoverContext } from "../popover-context";
import { PopoverPanelType } from "./interfaces";

import "./popover-panel.scss";

export const PopoverPanel: PopoverPanelType = ({
  children,
  className,
  ...rest
}) => {
  const {
    getBlocksWith,
    isOpen,
    panelPlacement,
    uniqueName,
    panelRef,
    handleOnPanelBlur,
  } = usePopoverContext();

  return (
    <div
      className={cn(
        className,
        getBlocksWith("__panel"),
        getBlocksWith(`__panel--${panelPlacement}`),
        isOpen && getBlocksWith("__panel--open"),
      )}
      id={`${uniqueName}-panel`}
      ref={panelRef}
      onBlur={handleOnPanelBlur}
      {...(isOpen && { tabIndex: 0 })}
      {...rest}
    >
      {isOpen && children}
    </div>
  );
};

export default PopoverPanel;
